import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { query } from 'umg-ember-backend/data/builders/umg-rest';

const RECORD_TYPE = 'division';

export default class AdminDivisionsIndexRoute extends Route {
  // Services
  @service breadcrumb;
  @service filter;
  @service store;

  // Hooks
  async model() {
    let queryObject = this.filter.getQueryObject(RECORD_TYPE);

    const { content } = await this.store.request(
      query(RECORD_TYPE, queryObject),
    );

    return content;
  }

  afterModel() {
    this.breadcrumb.registerExplorerRoute(RECORD_TYPE);
  }
}
